/**
 * Terranis processing engine type
 */
enum ProcessEngineType {
    BEFORE_WINTER_RAPESEED_BIOMASS = 'before-winter-rapeseed-biomass',
    EARLY_WINTER_RAPESEED_BIOMASS = 'early-winter-rapeseed-biomass',
    MIDDLE_WINTER_RAPESEED_BIOMASS = 'middle-winter-rapeseed-biomass',
    LATE_WINTER_RAPESEED_BIOMASS = 'late-winter-rapeseed-biomass',
    RAPESEED_TOTALN = 'rapeseed-totaln',
    WINTER_CEREALS_ABSN = 'winter-cereals-absn',
    WINTER_CEREALS_TOTALN = 'winter-cereals-totaln',
    VC_RAPESEED_FERTILIZATION = 'vc-rapeseed-fertilization',
    VC_PHENOLOGY = 'vc-phenology',
}

export default ProcessEngineType;
